/* tslint:disable */
/* eslint-disable */
/* @relayHash f5474572441719a0f9aea3211f65e187 */

import { ConcreteRequest } from "relay-runtime";
export type AwardStatusType = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
export type FirmDesignProfileAwardsMutationInput = {
    serviceId: string;
    awardIds: Array<string | null>;
    clientMutationId?: string | null;
};
export type profileAwardsMutationVariables = {
    input: FirmDesignProfileAwardsMutationInput;
};
export type profileAwardsMutationResponse = {
    readonly firmDesignProfileAwardsMutation: {
        readonly tradeFirm: {
            readonly publicProfile: {
                readonly awards: ReadonlyArray<{
                    readonly serviceId: string | null;
                    readonly name: string | null;
                    readonly status: AwardStatusType | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type profileAwardsMutation = {
    readonly response: profileAwardsMutationResponse;
    readonly variables: profileAwardsMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FirmDesignProfileAwardsMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileAwardsMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileAwardsMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileAwardsMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "awards",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AwardType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileAwardsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileAwardsMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileAwardsMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "awards",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AwardType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileAwardsMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileAwardsMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '7106ba400084c1aabca4f39947641d8d';
export default node;
